"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.757 20.937 12 20.5za.5.5 0 0 0 .486 0L12 20.5l.243.437.002-.001.006-.003.021-.012.029-.016.05-.03q.104-.06.294-.173a29 29 0 0 0 4.187-3.078c2.262-2.011 4.668-4.89 4.668-8.124 0-1.6-.468-2.875-1.242-3.796a4.67 4.67 0 0 0-2.937-1.612c-1.947-.28-4.088.582-5.321 2.528-1.233-1.946-3.374-2.809-5.321-2.528a4.67 4.67 0 0 0-2.937 1.612C2.968 6.624 2.5 7.9 2.5 9.5c0 3.233 2.406 6.113 4.668 8.124a29 29 0 0 0 4.56 3.297l.02.012.007.003z"
}), 'HeartFilled');
//# sourceMappingURL=index.js.map